import { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomAlert from "../../components/UI/CustomAlert/CustomAlert";

const AuthContext = createContext(null);
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [showSessionExpiredAlert, setShowSessionExpiredAlert] = useState({
    show: false,
    severity: "warning",
    header: "Session Expired",
    message: "Your session has expired due to inactivity. Please log in again.",
  });
  const navigate = useNavigate();

  const login = (user) => {
    setUser(user);
  };

  const logout = () => {
    sessionStorage.clear();
    setUser(null);
  };

  const resetSession = () => {
    logout(); // Clear session and user
    navigate("/"); // Redirect to login page
    setShowSessionExpiredAlert((prev) => ({ ...prev, show: true })); // Show the alert
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, resetSession }}>
      {children}
      <CustomAlert
        severity={showSessionExpiredAlert.severity}
        show={showSessionExpiredAlert.show}
        header={showSessionExpiredAlert.header}
        message={showSessionExpiredAlert.message}
        onClick={() => {
          setShowSessionExpiredAlert((prev) => ({ ...prev, show: false }));
          logout();
        }}
      />
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
